
export default {
    root: {
        borderRadius: '{content.border.radius}'
    }
};
